import * as React from "react";
import { BarChart } from "@mui/x-charts/BarChart";

export default function ThdChart({ data }) {
  // data: { THD_VLN1: 3.5, THD_VLN2: 2.8, THD_VLN3: 4.1 }

  const dataset = [
    { phase: "THD-V1", value: data?.THD_VLN1 ?? 0 },
    { phase: "THD-V2", value: data?.THD_VLN2 ?? 0 },
    { phase: "THD-V3", value: data?.THD_VLN3 ?? 0 },
  ];

  return (
    <BarChart
      dataset={dataset}
      xAxis={[{ dataKey: "phase", scaleType: "band" }]}
      yAxis={[{ min: 0, max: 100 }]}
      series={[{ dataKey: "value", label: "THD (%)", color: "#9333ea" }]}
      height={200}
    />
  );
}
